<template>
    <table class="data-table">
        <slot></slot>
    </table>
    </template>


<script>
export default {
  name: 'ListTable',
  
}
</script>